import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React from 'react';
import ButtonLoading from './contents/ButtonLoading.js';
import AnchorButton from '../common/AnchorButton.js';
import { BUTTON_BOX_SIZE, BUTTON_VARIANT } from '../../constants/button.js';
import styles from './ButtonBox.module.scss.js';

var _excluded = ["text", "size", "variant", "color", "disabled", "onClick"],
  _excluded2 = ["text", "size", "variant", "color", "disabled", "isWide", "onClick"],
  _excluded3 = ["text", "size", "variant", "color", "disabled", "isWide"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 *
 * 가능한 size > variant > (각 case의 가능한 props)
 *  - 공통 : disabled
 *  - `max`
 *    - `priamry` : loading
 *    - `secondary`
 *  - `large` | `medium` | `small`
 *    - `primary` | `secondary` | `tertiary` | `basic` : isWide
 *  - `tiny`
 *    - `primary` | `secondary` | `tertiary` | `basic` : isWide
 *  - `largefull`
 *    - `primary` : loading
 *    - `secondary` | `tertiary` | `basic`
 *
 */
function ButtonBox(props) {
  switch (props.size) {
    case BUTTON_BOX_SIZE.MAX:
    case BUTTON_BOX_SIZE.LARGE_FULL:
      {
        var text = props.text,
          size = props.size,
          variant = props.variant,
          color = props.color,
          disabled = props.disabled,
          onClick = props.onClick,
          anchorButtonProps = _objectWithoutProperties(props, _excluded);
        var isLoading = !disabled && variant === BUTTON_VARIANT.PRIMARY && props.loading;
        return /*#__PURE__*/React.createElement(AnchorButton, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, anchorButtonProps), {}, {
          loading: undefined,
          onClick: isLoading ? undefined : onClick
        })), {}, {
          className: cx('article', size, variant, color && "color-".concat(color), {
            disabled: disabled
          }),
          disabled: disabled
        }), isLoading ? /*#__PURE__*/React.createElement(ButtonLoading, {
          width: "30px",
          height: "8px"
        }) : /*#__PURE__*/React.createElement(React.Fragment, null, text));
      }
    case BUTTON_BOX_SIZE.LARGE:
    case BUTTON_BOX_SIZE.MEDIUM:
      {
        var _text = props.text,
          _size = props.size,
          _variant = props.variant,
          _color = props.color,
          _disabled = props.disabled,
          isWide = props.isWide,
          _onClick = props.onClick,
          _anchorButtonProps = _objectWithoutProperties(props, _excluded2);
        var _isLoading = !_disabled && _variant === BUTTON_VARIANT.PRIMARY && props.loading;
        var _BUTTON_BOX_SIZE$LARG = _defineProperty(_defineProperty({}, BUTTON_BOX_SIZE.LARGE, {
            width: '30px',
            height: '8px'
          }), BUTTON_BOX_SIZE.MEDIUM, {
            width: '27px',
            height: '7px'
          })[_size],
          loadingWidth = _BUTTON_BOX_SIZE$LARG.width,
          loadingHeight = _BUTTON_BOX_SIZE$LARG.height;
        return /*#__PURE__*/React.createElement(AnchorButton, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, _anchorButtonProps), {}, {
          loading: undefined,
          onClick: _isLoading ? undefined : _onClick
        })), {}, {
          className: cx('article', _size, _variant, _color && "color-".concat(_color), {
            disabled: _disabled
          }, {
            'type-wide': isWide
          }),
          disabled: _disabled
        }), _isLoading ? /*#__PURE__*/React.createElement(ButtonLoading, {
          width: loadingWidth,
          height: loadingHeight
        }) : /*#__PURE__*/React.createElement(React.Fragment, null, _text));
      }
    case BUTTON_BOX_SIZE.SMALL:
    case BUTTON_BOX_SIZE.TINY:
      {
        var _text2 = props.text,
          _size2 = props.size,
          _variant2 = props.variant,
          _color2 = props.color,
          _disabled2 = props.disabled,
          _isWide = props.isWide,
          _anchorButtonProps2 = _objectWithoutProperties(props, _excluded3);
        return /*#__PURE__*/React.createElement(AnchorButton, _objectSpread(_objectSpread({}, _anchorButtonProps2), {}, {
          className: cx('article', _size2, _variant2, _color2 && "color-".concat(_color2), {
            disabled: _disabled2
          }, {
            'type-wide': _isWide
          }),
          disabled: _disabled2
        }), _text2);
      }
  }
}

export { ButtonBox as default };
